import * as React from 'react';
import type { SVGProps } from 'react';
/**
 * @internal
 */
const JusticeLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="190"
    height="185"
    viewBox="0 0 190 185"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_319_742)">
      <mask
        id="mask0_319_742"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="190"
        height="185"
      >
        <path d="M189.72 0H0V184.088H189.72V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_319_742)">
        <g opacity="0.6">
          <path
            d="M107.484 8.31297C124.929 8.31297 139.593 12.263 151.5 18.777C137.394 8.27193 120.644 1.8961 103.123 0.361846C85.6016 -1.17241 67.9989 2.19536 52.2814 10.0889C36.5639 17.9824 23.3507 30.0907 14.1183 45.0609C4.88579 60.0312 -0.00235164 77.2737 8.48725e-07 94.862C8.48725e-07 141.694 33.782 181.781 80.633 181.781C117.999 181.781 143.113 160.826 154.633 131.954C160.953 116.162 156.48 97.603 142.126 87.854C126.135 76.985 105.658 81.419 94.913 97.763C91.4518 103.184 86.4912 107.484 80.6336 110.141C74.776 112.797 68.2731 113.697 61.9143 112.729C55.5556 111.762 49.6144 108.969 44.8119 104.691C40.0095 100.412 36.5523 94.8313 34.86 88.626H34.85C34.817 88.502 34.791 88.4 34.758 88.28C34.723 88.143 34.679 88.002 34.648 87.855C33.3911 83.5717 32.8174 79.117 32.948 74.655C32.9552 71.7899 33.2281 68.9317 33.763 66.117C38.28 37.49 66.03 8.31297 107.484 8.31297Z"
            fill="#1E46AC"
            fillOpacity="0.1"
          />
          <path
            d="M185.652 67.329C185.615 67.2 185.583 67.075 185.545 66.946C182.04 55.177 170.335 36.196 150.414 23.846C138.69 17.424 124.298 13.336 107.484 13.336C94.4231 13.2394 81.5797 16.6812 70.3173 23.296C59.0549 29.9108 49.7938 39.4517 43.517 50.906C42.1458 53.3829 40.9178 55.9364 39.839 58.554C50.407 40.164 73.329 28.598 96.729 28.598C117.473 28.598 137.368 36.838 152.037 51.5055C166.706 66.1731 174.948 86.0668 174.95 106.811C174.964 122.861 170.496 138.596 162.051 152.245C153.606 165.893 141.519 176.913 127.15 184.064L127.16 184.087C145.49 177.443 161.33 165.314 172.523 149.35C183.717 133.386 189.722 114.361 189.721 94.864C189.747 85.5346 188.375 76.254 185.652 67.331"
            fill="#1E46AC"
            fillOpacity="0.1"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_319_742">
        <rect width="189.72" height="184.088" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default JusticeLogo;
